"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurveMetaPoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
class CurveMetaPoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.dispatcher = {
            [chain_1.ParachainId.ARBITRUM_ONE]: '0x1B5a2f88420ff329406D108e641e52E46465F68e',
        };
    }
    getStartPoint() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'MetaPoolCode: Unseted chainId');
        return this.dispatcher[Number(chainId)];
    }
    getSwapCodeForRouteProcessor(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForRouteProcessor2(leg, _route, to) {
        const tokenFromIndex = leg.tokenFrom.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const tokenToIndex = leg.tokenTo.address?.toLowerCase() === this.pool.token0.address?.toLowerCase()
            ? this.pool.token0Index
            : this.pool.token1Index;
        const poolData = (0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, int128, int128, address'), [
            leg.poolAddress,
            BigInt(tokenFromIndex),
            BigInt(tokenToIndex),
            leg.tokenTo.address,
        ]);
        const code = new HEXer_1.HEXer()
            .uint8(7) // curve stable pool
            .bool(true) // isMetaSwap
            .address(to)
            .bytes(poolData)
            .toString();
        return code;
    }
}
exports.CurveMetaPoolCode = CurveMetaPoolCode;
